import React from "react";

export default function ChangeIcon() {
  const svgStyles = {
    cursor: "pointer",
  };

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={20}
      height={21}
      fill="none"
      style={svgStyles}
    >
      <path
        style={svgStyles}
        fill="#3E4957"
        fillRule="evenodd"
        d="M1.25 5.867c0-.345.28-.625.625-.625h14.741L12.683 1.31a.625.625 0 1 1 .884-.884l5 5a.625.625 0 0 1 0 .884l-5 5a.625.625 0 1 1-.884-.884l3.933-3.933H1.875a.625.625 0 0 1-.625-.625ZM18.75 14.617a.625.625 0 0 0-.625-.625H3.384l3.933-3.933a.625.625 0 1 0-.884-.884l-5 5a.625.625 0 0 0 0 .884l5 5a.625.625 0 1 0 .884-.884l-3.933-3.933h14.741c.345 0 .625-.28.625-.625Z"
        clipRule="evenodd"
      />
    </svg>
  );
}
